module.exports = __webpack_public_path__ + "static/media/happy.bd98d43a.gif";